import {Type, TypeImplementation} from '@packages/systems/wfdl';
import {
  TText,
  TTypeApplication,
  TTypeConstructor,
} from '@packages/systems/wfdl-ast';
import {qualify, typeName} from '@packages/systems/wfdl-Qualified';
import {pluginName} from '../constants';

/**
 * Utility string alias type whose purpose is to allow AnyOfConditionValue types
 * to have a list item type that carries a type argument into the contextual
 * expression provided to renderSummary.
 */
export const AnyOfListItemType = TypeImplementation.Alias({
  params: ['anyOfListItem'],
  type: TText,
  render: () => null,
});

export const TAnyOfListItem = (arg: Type) =>
  TTypeApplication({
    con: TTypeConstructor(qualify(pluginName, typeName('AnyOfListItem'))),
    arg,
  });
